import axios from 'axios'
import * as Redux from 'redux'
import SharedActions from '@SharedActions/loading.action'
import { APIServices } from '@Services/api.service'
import { ToastServices } from '@Services/toast.service'
import { ClientActionTypes } from '../client.action-types'

const updateStolenOrLost = (id: string, payload: any, cb: any) => {
    return (dispatch: Redux.Dispatch) => {
        APIServices.axiosConfig()
        const url = `${APIServices.apiUrlV1}/admin/items/${id}/status`
        // return new Promise((resolve, reject) => {
        //     axios
        //         .put(url, payload)
        //         .then((response) => {
        //             ToastServices.success('Status Updated')
        //             resolve(response)
        //         })
        //         .catch((errors) => {
        //             const message = errors?.response?.data?.message
        //             ToastServices.error(message || 'Unspecific errors!')
        //             reject(errors)
        //         })
        // })
        // return new Promise((resolve, reject) => {
        axios
            .put(url, payload)
            .then((response) => {
                ToastServices.success('Status Updated')
                cb('success')

                // resolve(response)
            })
            .catch((errors) => {
                const message = errors?.response?.data?.message
                ToastServices.error(message || 'Unspecific errors!')
                // reject(errors)
                cb('error')
            })
        // })
    }
}

const getInstructionLetter = (id: string) => {
    return (dispatch: Redux.Dispatch) => {
        dispatch({
            type: ClientActionTypes.GET_INSTRUCTION_LETTER,
            payload: '',
        })
        dispatch(SharedActions.setClientLoading(true) as any)
        APIServices.axiosConfig()
        return new Promise((resolve, reject) => {
            const url = `${APIServices.apiUrlV1}/admin/items/${id}/lost-disposes/forms`

            axios
                .get(url)
                .then((response) => {
                    dispatch(SharedActions.setClientLoading(false) as any)
                    resolve(response)
                    dispatch({
                        type: ClientActionTypes.GET_INSTRUCTION_LETTER,
                        payload: response?.data,
                    })
                })
                .catch((errors) => {
                    dispatch(SharedActions.setClientLoading(false) as any)
                    const message = errors?.response?.data?.message
                    ToastServices.error(message || 'Unspecific errors!')
                    reject(errors)
                })
        })
    }
}

const ClientMyVaultActions = {
    updateStolenOrLost,
    getInstructionLetter,
}

export default ClientMyVaultActions
